export default __webpack_public_path__ + "static/media/ledgerIcon.0f85585e.svg";